class ShopByCategory extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        this.initializeSwiper();
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
    }

    initializeSwiper() {
        // Wait for Swiper to be available
        if (typeof Swiper === 'undefined') {
            // If Swiper is not loaded yet, try again after a short delay
            setTimeout(() => this.initializeSwiper(), 100);
            return;
        }

        const slider = this.querySelector('.shop-by-category__slider');
        if (!slider) return;

        // Add Swiper wrapper and slide classes
        slider.classList.add('swiper');

        // Move all cards into the wrapper and add swiper-slide class
        const cards = slider.querySelectorAll('.shop-by-category__card');
        cards.forEach(card => {
            card.classList.add('swiper-slide');
        });

        // Initialize Swiper
        this.swiper = new Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 24,
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {

                991: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
            // Add some styling options
            speed: 300,
            autoplay: false,
            grabCursor: true,
            watchOverflow: true,
        });
    }
}

// Register the custom element
customElements.define('shop-by-category', ShopByCategory); 